export default "__VITE_ASSET__df2e1b36__"